/**
 * Admin router.
 *
 * Public:
 *   /login
 *
 * Auth-required (wrapped in <RequireAuth />):
 *   /dashboard        Everyone
 *   /members          Secretary / Coordinator        (Stage 3.3a)
 *   /payments         Treasurer / Coordinator        (Stage 3.3b)
 *   /content/posts    Secretary / Editor / Coord     (Stage 3.3c)
 *   /content/pages    Secretary / Editor / Coord     (Stage 3.3c)
 *   /events           Secretary / Coordinator        (Stage 3.3d)
 *   /gallery          Everyone (read) — write gated  (Stage 3.3e)
 *   /committee        Coordinator                    (Stage 3.3f)
 *   /settings         Coordinator                    (Stage 3.3g)
 *   /audit            Coordinator                    (Stage 3.3h)
 *   /users            Coordinator                    (Stage 3.3i)
 *
 * Stub screens render a "coming in Stage 3.3x" placeholder for now so the
 * navigation works end-to-end.
 */
import { Navigate, Route, Routes } from "react-router-dom";

import { RequireAuth } from "./auth/RequireAuth";
import { AdminShell } from "./layout/AdminShell";
import { BannersScreen } from "./screens/BannersScreen";
import { DashboardScreen } from "./screens/DashboardScreen";
import { GalleryScreen } from "./screens/GalleryScreen";
import { LoginScreen } from "./screens/LoginScreen";
import { MembersScreen } from "./screens/MembersScreen";
import { PostsScreen } from "./screens/PostsScreen";
import { SiteSettingsScreen } from "./screens/SiteSettingsScreen";
import { PlaceholderScreen } from "./screens/PlaceholderScreen";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />

      <Route
        element={
          <RequireAuth>
            <AdminShell />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardScreen />} />

        <Route path="/members"        element={<MembersScreen />} />
        <Route path="/payments"       element={<PlaceholderScreen title="Payments"       stage="3.3b" />} />
        <Route path="/plans"          element={<PlaceholderScreen title="Membership plans" stage="3.3b" />} />
        <Route path="/content/posts"  element={<PostsScreen />} />
        <Route path="/content/pages"  element={<PlaceholderScreen title="Pages"          stage="3.3c" />} />
        <Route path="/events"         element={<PlaceholderScreen title="Events"         stage="3.3d" />} />
        <Route path="/banners"        element={<BannersScreen />} />
        <Route path="/gallery"        element={<GalleryScreen />} />
        <Route path="/committee"      element={<PlaceholderScreen title="Committee"      stage="3.3f" />} />
        <Route path="/settings"       element={<SiteSettingsScreen />} />
        <Route path="/audit"          element={<PlaceholderScreen title="Audit log"      stage="3.3h" />} />
        <Route path="/users"          element={<PlaceholderScreen title="Users"          stage="3.3i" />} />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
